import axios from '../axios';
// 列表
export const getPurAccessPage = data => {
  return axios({
    url: '/api/sys/pur/access/getPurAccessPage',
    method: 'post',
    data
  })
};
// 查询评铁记录
export const getPurAccessAndDetailList = data => {
  return axios({
    url: '/api/sys/pur/access/getPurAccessAndDetailList',
    method: 'post',
    data
  })
};
// 保存评铁记录
export const savPurAccessAndDetail = data => {
  return axios({
    url: '/api/sys/pur/access/savPurAccessAndDetail',
    method: 'post',
    data
  })
};
// 修改评铁记录
export const updPurAccessAndDetail = data => {
  return axios({
    url: '/api/sys/pur/access/updPurAccessAndDetail',
    method: 'post',
    data
  })
};
// 删除评铁记录
export const deletePurAccesss = data => {
  return axios({
    url: '/api/sys/pur/access/deletePurAccesss',
    method: 'post',
    data
  })
};
// 评铁确认
export const auditPurAccesss = data => {
  return axios({
    url: '/api/sys/pur/access/auditPurAccesss',
    method: 'post',
    data
  })
};
// 评铁反确认
export const unauditPurAccesss = data => {
  return axios({
    url: '/api/sys/pur/access/unauditPurAccesss',
    method: 'post',
    data
  })
};



// WEBPACK FOOTER //
// ./src/api/moudules/access.js